"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoomMapSelectMessage = void 0;
var joi_1 = __importDefault(require("joi"));
var message_1 = require("../../message");
exports.RoomMapSelectMessage = message_1.createMessage('room/map/select', joi_1.default.object({
    mapId: joi_1.default.string().required()
}))
    .withResponse();
